import { render, staticRenderFns } from "./InitialUserRightPanel.vue?vue&type=template&id=b0e6cfae&scoped=true&"
import script from "./InitialUserRightPanel.vue?vue&type=script&lang=js&"
export * from "./InitialUserRightPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e6cfae",
  null
  
)

export default component.exports